module.exports = __webpack_public_path__ + "img/preview-5.d6e08da8.png";